export class LanguageMenu {
	constructor() {
		this.languageMenus = document.querySelectorAll(".language-menu");

		if (this.languageMenus.length === 0) {
			return;
		}

		this.menuData = new Map();

		this.languageMenus.forEach((menu) => {
			const toggle = menu.querySelector(".language-menu__toggle");
			const nav = menu.querySelector(".language-menu__nav");

			if (toggle && nav) {
				this.menuData.set(menu, {
					toggle,
					nav,
					trigger: null,
				});
			}
		});

		this.addEventListeners();
	}

	addEventListeners() {
		this.menuData.forEach((data, menu) => {
			const { toggle } = data;

			toggle.addEventListener("click", () => {
				if (this.getState(menu) === "closed") {
					this.open(menu);
				} else {
					this.close(menu);
				}
			});

			menu.addEventListener("pointerenter", (event) => {
				if (event.pointerType === "mouse") {
					this.open(menu);
					data.trigger = "hover";
				}
			});

			menu.addEventListener("pointerleave", (event) => {
				if (event.pointerType === "mouse") {
					this.close(menu);
				}
			});
		});

		// Close menu when clicking outside
		this.handleClickOutside = (event) => {
			this.menuData.forEach((_, menu) => {
				if (this.getState(menu) === "open" && !menu.contains(event.target)) {
					this.close(menu);
				}
			});
		};

		document.addEventListener("click", this.handleClickOutside);
	}

	getState(menu) {
		const data = this.menuData.get(menu);
		if (!data) return "closed";

		const expanded = data.toggle.getAttribute("aria-expanded") === "true";
		return expanded ? "open" : "closed";
	}

	open(menu) {
		if (menu) {
			// Open specific menu
			const data = this.menuData.get(menu);
			if (data) {
				data.toggle.setAttribute("aria-expanded", "true");
			}
		} else {
			// Open all menus
			this.menuData.forEach((data) => {
				data.toggle.setAttribute("aria-expanded", "true");
			});
		}
	}

	close(menu) {
		if (menu) {
			// Close specific menu
			const data = this.menuData.get(menu);
			if (data) {
				data.toggle.setAttribute("aria-expanded", "false");
			}
		} else {
			// Close all menus
			this.menuData.forEach((data) => {
				data.toggle.setAttribute("aria-expanded", "false");
			});
		}
	}

	destroy() {
		document.removeEventListener("click", this.handleClickOutside);
	}
}
